import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonUtilService } from 'app/services/commonUtil.service';
import { SpinnerService } from 'app/services/spinner.service';
import { RegisterService } from 'app/services/user/register.service';

@Component({
  selector: 'ms-contract-sign-signing-process',
  templateUrl: './contract-sign-signing-process.component.html',
  styleUrls: ['./contract-sign-signing-process.component.css']
})
export class ContractSignSigningProcessComponent implements OnInit {

  submitted = false;
  error = false;
  registerId: any;
  data: any;
  file_error = false;
  dataJSON: any;

  contractForm: FormGroup;

  constructor(private activatedRouter: ActivatedRoute,
    private router: Router,
    private registerService: RegisterService,
    private formBuilder: FormBuilder,
    private commonUtilService: CommonUtilService,
    private spinnerService: SpinnerService) { }

  ngOnInit(): void {
    this.spinnerService.start();
    this.registerId = this.activatedRouter.snapshot.paramMap.get("registerId");
    this.contractForm = this.createContractFormBuilder(this.formBuilder);
    this.registerService.getUserContractDocument(this.registerId).subscribe(data => {
      if(data){
        this.data = data;
        this.contractForm = this.createContractFormBuilder(this.formBuilder);
      }
    });
    this.spinnerService.stop();
  }

  get f() { return this.contractForm.controls; }

  get val() { return this.contractForm.value; }

  createContractFormBuilder = (formBuilder: FormBuilder) => {
    return formBuilder.group({
      contract: [(this.data && this.data.contract) ? this.data.contract.name : '', [Validators.required]],
      contractfileBinary: [this.data && this.data.contract ? this.data.contract.fileBinary : '', [Validators.required]],
    });
  }

  onFileChange(event, field, form) {
    this.spinnerService.start();
    const reader = new FileReader();
    if (event.target.files.length > 0) {
      this.file_error = false;
      const file = event.target.files[0];
      reader.readAsDataURL(file);
      reader.onload = () => {
        let kb = file.size / 1024;
        let mb = kb / 1024;
        let sizeParsed = parseFloat(mb.toString());
        if (sizeParsed >  20) {
          this.file_error = true;
          return;
        }
        form.get(field).setValue({
          name: file.name,
          filetype: file.type
        });
        form.get(field + 'fileBinary').setValue({
          name: reader.result
        });
      };
    }
    this.spinnerService.stop();
  }

  onSubmit() {
    this.spinnerService.start();
    this.submitted = true;
    this.error = false;

    if (this.contractForm.invalid) {
      this.commonUtilService.findInvalidControls(this.contractForm);
      this.spinnerService.stop();
      return;
    }

    this.dataJSON = {
      contract: {
        name: this.val.contract.name ? this.val.contract.name : this.val.contract,
        fileBinary: this.val.contractfileBinary.name ? this.val.contractfileBinary.name : this.val.contractfileBinary,
      }
    }

    this.registerService.addUserContractDocument(this.registerId, this.dataJSON).subscribe(data => {
      this.registerService.createHrweUser(this.registerId).subscribe(data => {
        this.goToContractSignSuccess();
      }, err => {
        this.error = true;
        this.spinnerService.stop();
        setTimeout(()=>{                           
          this.error = false;
        }, 2000);
      });
    })
  }

  goToContractSignSuccess() {
    this.spinnerService.start();
    this.router.navigate(['/registrazione/' + this.registerId + '/contract/success']);
  }

}
